import React from 'react';
import { AssetIcon } from '../../assets';

export default function SearchField({
  value,
  onChange,
  placeholder = 'Cerca...',
  label = 'Cerca',
  className = '',
  iconName = 'actions.search',
}) {
  return (
    <label className={className ? `wt-search-field ${className}` : 'wt-search-field'}>
      <span className="sr-only">{label}</span>
      <AssetIcon name={iconName} size={16} />
      <input
        type="search"
        value={value}
        onChange={(event) => onChange?.(event.target.value)}
        placeholder={placeholder}
      />
    </label>
  );
}
